import { useState } from 'react';

export default function CTAOne() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage('Please enter your email address');
      return;
    }

    setIsSubmitting(true);
    setMessage('');

    try {
      const response = await fetch('/api/newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email: email,
          source: 'cta'
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage('Thank you! You\'ve been subscribed to our special offers.');
        setEmail('');
      } else {
        setMessage(result.error || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      setMessage('Network error. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="cta-one">
      <div className="container">
        <div className="cta-one__inner">
          <h3 className="cta-one__title">
            Stay Connected for Special Offers
          </h3>
          <form
            className="cta-one__form"
            onSubmit={handleSubmit}
          >
            <div className="cta-one__form-input-box">
              <input
                type="email"
                placeholder="Enter your email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
                required
              />
              <button 
                type="submit" 
                className="cta-one__btn"
                disabled={isSubmitting}
              >
                <span className="icon-paper-plan"></span>
              </button>
            </div>
            {message && (
              <p className="cta-one__message" style={{
                marginTop: '15px',
                textAlign: 'center',
                fontSize: '16px',
                color: message.includes('Thank you') ? '#28a745' : '#dc3545',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                padding: '10px',
                borderRadius: '5px'
              }}>
                {message}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
